/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { Entite } from '@/types/Entite';

type EntiteStoreType = {
  blocked: boolean;
  refresh: boolean;
  selectedEntite: null | Entite;
  selectEntite: (entite: Entite) => void;
  setBlocked: (blocked: boolean) => void;
  setRefresh: (refresh: boolean) => void;
};

const useEntiteStore = create<EntiteStoreType>()(
  devtools((set) => ({
    blocked: true,
    refresh: false,
    selectedEntite: null,
    selectEntite: (selectedEntite) => set({ selectedEntite }),
    setBlocked: (blocked) => set({ blocked }),
    setRefresh: (refresh) => set({ refresh }),
  })),
);

export default useEntiteStore;
